import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { DashboardKPI } from '../types/dashboard.types';

interface KPICardProps {
  kpi: DashboardKPI;
}

export const KPICard: React.FC<KPICardProps> = ({ kpi }) => {
  const formatValue = (value: string | number, format?: string): string => {
    if (format === 'currency') {
      return `S/ ${Number(value).toLocaleString('es-PE', { minimumFractionDigits: 2 })}`;
    }
    if (format === 'percentage') {
      return `${value}%`;
    }
    return value.toString();
  };

  const getChangeColor = (changeType?: 'increase' | 'decrease' | 'neutral'): string => {
    switch (changeType) {
      case 'increase':
        return 'text-green-600';
      case 'decrease':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  const renderChangeIcon = (changeType?: 'increase' | 'decrease' | 'neutral') => {
    if (changeType === 'increase') {
      return <TrendingUp className="h-4 w-4" />;
    }
    if (changeType === 'decrease') {
      return <TrendingDown className="h-4 w-4" />;
    }
    return null;
  };

  const formatChange = (change?: number): string => {
    if (change === undefined) return '';
    return `${change}%`;
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-gray-600">
          {kpi.title}
        </CardTitle>
        <div className="text-macartur-primary">
          {/* Aquí se renderizaría el ícono basado en kpi.icon */}
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold text-gray-900">
          {formatValue(kpi.value, kpi.format)}
        </div>
        {kpi.change !== undefined && (
          <div className="flex items-center mt-2">
            {renderChangeIcon(kpi.changeType)}
            <span className={`text-sm ml-1 ${getChangeColor(kpi.changeType)}`}>
              {formatChange(kpi.change)}
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
};